// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".combo-img[data-v-7b0ab135]{border-radius:10px;border:2px solid #9b9b9b;height:auto;width:100%}", ""]);
// Exports
module.exports = exports;
